import React from 'react';
import { MapPin, BadgeIndianRupee, BedDouble, Headphones, Heart, ShieldCheck } from 'lucide-react';
import { WHY_CHOOSE, STATS } from '../../mock';

const ICONS = { MapPin, BadgeIndianRupee, BedDouble, Headphones, Heart, ShieldCheck };

export default function WhyChooseUs() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-20 lg:py-28">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-brand-orange text-[13px] font-semibold tracking-[0.18em] uppercase mb-2">Why Mountains Chain</div>
        <h2 className="font-poppins text-[34px] lg:text-[44px] text-brand-blue leading-[1.1]">We don’t plan trips. <span className="text-brand-orange">We craft memories.</span></h2>
        <p className="text-brand-blue/65 mt-4 text-[15px]">Every traveler is a guest, not a customer. From the first call to the last goodbye, we are with you.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {WHY_CHOOSE.map((w, i) => {
          const Icon = ICONS[w.icon] || ShieldCheck;
          return (
            <div key={i} className="group bg-white rounded-2xl p-7 border border-brand-greyDark hover:border-brand-orange/30 shadow-card hover:shadow-premium transition-all duration-300 animate-fade-up" style={{animationDelay: `${i * 70}ms`}}>
              <div className="w-12 h-12 rounded-xl bg-brand-blue text-brand-orange flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-transform">
                <Icon size={22} />
              </div>
              <h3 className="font-poppins font-semibold text-brand-blue text-[18px] mt-5">{w.title}</h3>
              <p className="text-brand-blue/65 text-[14px] leading-relaxed mt-2">{w.text}</p>
            </div>
          );
        })}
      </div>

      {/* Stats strip */}
      <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-brand-greyDark rounded-2xl overflow-hidden border border-brand-greyDark">
        {STATS.map((s, i) => (
          <div key={i} className="bg-white p-6 lg:p-8 text-center">
            <div className="font-poppins font-bold text-[32px] lg:text-[40px] text-brand-blue leading-none">{s.value}</div>
            <div className="text-brand-blue/60 text-[13px] mt-2 font-medium">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
